import { render, staticRenderFns } from "./newsDokumentari.vue?vue&type=template&id=78f4e492&scoped=true&"
import script from "./newsDokumentari.vue?vue&type=script&lang=js&"
export * from "./newsDokumentari.vue?vue&type=script&lang=js&"
import style0 from "./newsDokumentari.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsDokumentari.vue?vue&type=style&index=1&id=78f4e492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4e492",
  null
  
)

export default component.exports